export enum Storage {
  CardListFilter = 'SmartCard-CardList-Filter'
}
